import Order from 'types/entities/Order';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import Scope from 'types/entities/Scope';
import User from 'types/entities/User';
import { AffectationSearch } from './BaselineAffectationContext';

type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

// eslint-disable-next-line no-shadow
export enum BaselineAffectationType {
  ChangePage = 'CHANGE_PAGE_OWU_AFFECTATIONS',
  ChangePageSize = 'CHANGE_PAGE_SIZE',
  LoadDeliverable = 'LOAD_DELIVERABLE',
  Inject = 'INJECT_OWU_AFFECTATIONS',
  InjectOrder = 'INJECT_ORDER',
  InjectScopes = 'INJECT_SCOPES',
  OpenEditDrawer = 'OPEN_EDIT_DRAWER',
  CloseEditDrawer = 'CLOSE_EDIT_DRAWER',
  ChangeTotalItems = 'CHANGE_TOTAL_ITEMS',
  ChangeTotalPages = 'CHANGE_TOTAL_PAGES',
  UpdateBaseline = 'UPDATE_ORDER_WORKUNIT',
  UpdateSearch = 'UPDATE_SEARCH',
  SelectAffectationItems = 'SELECT_AFFECTATION_ITEMS',
  GridIsLoading = 'GRID_IS_LOADING',
  GridNotLoading = 'GRID_NOT_LOADING',
  BulkUpdateBaseline = 'BULK_UPDATE_ORDER_WORKUNIT',
  SetAffectationConsultants = 'SET_AFFECTATION_CONSULTANTS',
  SetAffectationClients = 'SET_AFFECTATION_CLIENTS',
  SetAffectationDM = 'SET_AFFECTATION_DM',
}

// eslint-disable-next-line @typescript-eslint/ban-types
type BaselineAffectationPayload = {
  [BaselineAffectationType.Inject]: {
    baseLineOrderWorkunits: OrderWorkunit[];
    totalItems: number;
    totalPages: number;
    currentPage: number;
  };
  [BaselineAffectationType.ChangePage]: { newPage: number };
  [BaselineAffectationType.ChangePageSize]: { newPageSize: number };
  [BaselineAffectationType.LoadDeliverable]: null;
  [BaselineAffectationType.InjectOrder]: { order: Order | null };
  [BaselineAffectationType.InjectScopes]: { scopes: Scope[] };
  [BaselineAffectationType.OpenEditDrawer]: undefined;
  [BaselineAffectationType.CloseEditDrawer]: undefined;
  [BaselineAffectationType.ChangeTotalItems]: { totalItems: number };
  [BaselineAffectationType.ChangeTotalPages]: { totalPages: number };
  [BaselineAffectationType.UpdateBaseline]: { baseLineOrderWorkunit: OrderWorkunit | Partial<OrderWorkunit> };
  [BaselineAffectationType.UpdateSearch]: { field: keyof AffectationSearch; value: any };
  [BaselineAffectationType.SelectAffectationItems]: { baselineIds: OrderWorkunit['id'][] };
  [BaselineAffectationType.GridIsLoading]: undefined;
  [BaselineAffectationType.GridNotLoading]: undefined;
  [BaselineAffectationType.BulkUpdateBaseline]: Partial<OrderWorkunit>;
  [BaselineAffectationType.SetAffectationConsultants]: { consultants: User[] };
  [BaselineAffectationType.SetAffectationClients]: { clients: User[] };
  [BaselineAffectationType.SetAffectationDM]: { deliveryManagers: User[] };
};

export type PossiblesBaselineAffectationActions =
  ActionMap<BaselineAffectationPayload>[keyof ActionMap<BaselineAffectationPayload>];
